<template>
  <div class="charge_data">

    <div class="title_box clearfix">
      <p class="title fl">{{$t('charger.charger_data')}} </p>
      <!-- <span class="fl"></span> -->
      <div class="fr">
        <el-button type="primary" @click="showCurve = true" :disabled="!chargerInfo.chargerModel">
          {{$t('charger.modify_curve')}} </el-button>
        <el-button type="primary" @click="toRecord" :disabled="!chargerInfo.chargerId" style="margin-left: 20px;">
          {{$t('charger.inquiry_record')}}
        </el-button>
      </div>

    </div>

    <div class="cell_groud clearfix">
      <div class="cell fl">
        <span class="label">{{$t('charger.update_time')}}</span>
        {{ handleTime(chargerInfo.updateTime) }}
      </div>
      <div class="cell fl">
        <span class="label">SN</span>
        {{chargerInfo.chargerId ? chargerInfo.chargerId: '--'}}
      </div>
      <!-- 机型 -->
      <div class="cell fl">
        <span class="label">{{$t('charger.model')}}</span>
        {{ chargeModule? chargeModule: (chargerInfo.chargerModel? chargerInfo.chargerModel:'--')}}
        <!-- {{_getQrCodeData(chargerInfo.chargerId)}} -->
      </div>
      <div class="cell fl">
        <span class="label">{{$t('charger.version_number')}}</span>
        {{chargerInfo.chargerFwVersion}}
      </div>
      <!-- <div class="cell fl">
        <span class="label">{{$t('charger.network_status')}}</span>
        {{chargerInfo.chargerNetStatus == 1? $t('charger.online'): $t('charger.offline')}}
      </div> -->
      <div class="cell fl">
        <span class="label">{{$t('charger.curve_number')}}</span>
        {{ curveNumComp }}
        <span class="desc"
          v-if="curveInfo.manufacturer">({{curveInfo.manufacturer + '/' + curveInfo.descriptions}})</span>
      </div>
      <div class="cell fl">
        <span class="label">{{$t('charger.charging_stage')}}</span>
        {{ handleStage(chargerInfo.chargerStage) }}
      </div>

      <div class="cell fl">
        <span class="label">{{$t('charger.charger_temp')}}</span>
        {{chargerInfo.chargerTemperature | temHandler}} {{tUnit()}}
      </div>
      <div class="cell fl">
        <span class="label">{{$t('charger.charging_power')}}</span>
        {{chargerInfo.currentAh | numHandler}} Ah
      </div>

      <div class="cell fl">
        <span class="label">{{$t('charger.error_mess')}}</span>
        {{handleError(chargerInfo.errorInfo) }}
      </div>

      <div class="cell fl">
        <span class="label">{{$t('charger.battery_temp')}}</span>
        {{chargerInfo.libatteryTemperature | temHandler}} {{tUnit()}}
      </div>
      <div class="cell fl">
        <span class="label">{{$t('charger.output_current')}}</span>
        {{chargerInfo.outputCurrent | numHandler}} A
      </div>
      <div class="cell fl">
        <span class="label">{{$t('charger.output_voltage')}}</span>
        {{chargerInfo.outputVoltage | numHandler}} V
      </div>
      <div class="cell fl">
        <span class="label">{{$t('charger.mains_frequency')}}</span>
        {{chargerInfo.supplyFrequence? chargerInfo.supplyFrequence: '--'  }} Hz
      </div>
      <div class="cell fl">
        <span class="label">{{$t('charger.supply_voltage')}}</span>
        {{chargerInfo.supplyVoltage | numHandler }} V
      </div>
      <div class="cell fl">
        <span class="label">{{$t('charger.working_status')}}</span>
        {{handleStatus(chargerInfo.chargerStatus) }}
      </div>

    </div>

    <!-- 修改曲线弹窗 -->
    <el-dialog :title="$t('charger.select_curve')" :visible.sync="showCurve" width="40%" @open="getChargeCurves">
      <!-- <el-cascader v-model="curveName" :props="props" @change="curveChange" style="width: 300px;"></el-cascader> -->
      <el-select v-model="manufacturer" :placeholder="$t('button.select') + ' ' + $t('adminView.manufacturer')"
        style="width: 300px; margin-bottom: 10px;" @change="getCurvesName">
        <el-option v-for="(item, index) in mList" :key="index" :label="item" :value="item">
        </el-option>
      </el-select>

      <el-select v-model="descriptions" :placeholder="$t('button.select') + ' ' + $t('QR.Profile')"
        :disabled="desList.length <= 0" style="width: 300px; margin-bottom: 10px;" @change="curveChange">
        <el-option v-for="(item, index) in desList" :key="index"
          :label="item.descriptions + '  (' + item.curveNum + ')'" :value="index">
        </el-option>
      </el-select>
      <p v-show="descriptions && confirmDis" style="color: #ff0000; margin-left: 10px;">
        {{$t('charger.curve_not_available')}}</p>

      <div class="clearfix" style="margin-top: 10px;">
        <el-button class="fr" type="primary" @click="confirmCurve" :disabled="confirmDis"> {{$t('charger.submit')}}
        </el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

import { getChargeInfo, manufacturerList, descriptionList, descriptionList2, findCurveBase, updateDeviceCurve, getSimpleCurve, touchChargerInfo, getQrCodeData } from "@/api"
import { updateTime } from "@/utils/updateTime"
import { temChange, temUnit } from '@/utils/temChange.js'
export default {
  data () {
    return {
      chargerInfo: {
        chargerFwVersion: '--',
        chargerId: "",
        chargerModel: '',
        chargerNetStatus: '',
        chargerStage: '',
        chargerStatus: '',
        chargerTemperature: '',
        currentAh: '',
        curveNum: '',
        errorInfo: "",
        libatteryTemperature: '',
        mcuId: null,
        outputCurrent: '',
        outputVoltage: '',
        supplyFrequence: '',
        supplyVoltage: '',
        updateTime: '',
        yhubStime: ''
      },
      showCurve: false,
      mList: [], // 1制造商列表 
      confirmDis: true,
      curveData: null,
      curveInfo: {
        battery: null,
        capacity: null,
        createTime: null,
        curveNumber: null,
        delFlag: null,
        descriptions: null,
        id: null,
        manufacturer: null,
        remark: null
      },
      curveName: [],
      yhubmqtt: {},
      tUnit: temUnit,
      stopTimeOut: false,
      chargeModule: '',
      manufacturer: '',
      descriptions: '',
      desList: []
    }
  },
  computed: {
    mcuId () {
      return this.$route.query.mcuId
    },
    props () {
      return {
        lazy: true,
        lazyLoad: this.lazyLoad
      }
    },
    storeYhubmqtt () {
      // console.log('------', this.$store.state.yhubmqtt)
      return this.$store.state.yhubmqtt// 需要监听的数据
    },
    curveNum () {
      return this.chargerInfo.curveNum
    },
    curveNumComp () {
      let val = this.chargerInfo.curveNum
      if (val) {
        if (val < 10) return 'b0' + val
        if (val < 100) return 'b' + val
        return val
      }
      return '--'
    }
  },
  watch: {
    storeYhubmqtt: {
      handler (newValue, oldValue) {
        this.yhubmqtt = newValue // 把新值赋值给我们的属性数据
        // console.log(this.yhubmqtt)
        // console.log(this.yhubmqtt.payload)
        // this.MQTT()
        this.mqttHandle()
      },
      deep: true
    },
    curveNum (val) {
      this.getCurveName(val)
    }
  },
  filters: {
    numHandler (val) {
      if (val) {
        return (val / 100).toFixed(2)
      }
      return '--'
    },
    temHandler (val) {
      return temChange(val / 100)
    }
  },
  mounted () {
    this.initData()
    
  },
  beforeDestroy () {
    this.stopTimeOut = true
  },
  methods: {
    
    _getQrCodeData (sn) {
      if (!sn) return
      getQrCodeData(sn).then(res => {
        console.log(res)
        if (res.resultCode == 1001 && res.resultModel) {
          if (res.resultModel.chargeModule) {
            this.chargeModule = res.resultModel.chargeModule
          }
        }
      })
    },
    _touchChargerInfo () {
      touchChargerInfo(this.mcuId).then(res => {
        console.log('触发更新充电器信息', res)
        // if (!this.stopTimeOut) {
        //   setTimeout(() => {
        //     this._touchChargerInfo()
        //   }, 15000);
        // }
      })
    },
    mqttHandle () {
      console.log(1)
      // if (this.yhubmqtt) {
      // if (!this.yhubmqtt.topic || this.yhubmqtt.topic.indexOf(this.mcuid) == -1) return
      if (this.yhubmqtt.topic == 'gpd/p/04/' + this.mcuId) {
        console.log(this.yhubmqtt.topic)
        console.log(this.yhubmqtt)

        if (this.yhubmqtt.mCan) {
          console.log('mcan:', this.yhubmqtt.mCan)
          let data = this.yhubmqtt.mCan.mChargerControl.chargerinfo
          /*
            chargerFwVersion: 9
            chargerMode: 3024
            chargerNetStatus: 1
            chargerStage: 1
            chargerTemperature: 3800
            curveNum: 40
            libatteryTemperature: 2700
            outputCurrent: 2100
            outputVoltage: 700
            supplyFrequence: 49
            supplyVoltage: 22990
            time: 1630655772
          */
          if (data) {
            this.chargerInfo.chargerFwVersion = data.chargerFwVersion
            // this.chargerInfo.chargerModel = data.chargerMode
            this.chargerInfo.chargerNetStatus = data.chargerNetStatus
            this.chargerInfo.chargerStage = data.chargerStage
            this.chargerInfo.chargerTemperature = data.chargerTemperature
            this.chargerInfo.outputCurrent = data.outputCurrent
            this.chargerInfo.outputVoltage = data.outputVoltage
            this.chargerInfo.supplyFrequence = data.supplyFrequence
            this.chargerInfo.supplyVoltage = data.supplyVoltage
            this.chargerInfo.curveNum = data.curveNum
            this.chargerInfo.libatteryTemperature = data.libatteryTemperature
            this.chargerInfo.errorInfo = data.errorInfo

            if (data.time) {
              this.chargerInfo.updateTime = data.time * 1000
            }

          }
        }
      }

      // }
    },
    toRecord () {
      this.$router.push({
        path: '/QR/chargerReportDetail?sn=' + this.chargerInfo.chargerId + '&mcuId=' + this.mcuId
      })
    },
    confirmCurve () {
      this.confirmDis = true
      updateDeviceCurve({
        "curveNumNew": this.curveData.curveNum,
        "curveSource": this.curveData.source,
        "idList": [
          {
            "curveNumOld": this.chargerInfo.curveNum,
            "deviceId": this.chargerInfo.chargerId,
            "mcuId": this.mcuId
          }
        ]
      }).then(res => {
        console.log('更新曲线结果', res)
        if (res.resultCode == 1001) {
          this.$message({
            message: this.$t('charger.succ_modified'),
            type: 'success'
          });
          this.showCurve = false

          this._touchChargerInfo()
        } else {
          this.$message.error(res.resultMessage);
        }
      })
    },
    getCurveName (num) {
      if (!num) return
      if (num < 100) num = 'b' + num
      getSimpleCurve(num).then(res => {
        console.log(res)
        if (res.resultCode == 1001) {
          this.curveInfo = res.resultModel
          this.curveName = [this.curveInfo.manufacturer, this.curveInfo.descriptions]
        }
      })
    },
    initData () {
      getChargeInfo({
        "chargerId": this.mcuId
      }).then(res => {
        console.log(res)
        if (res.resultCode == 1001 && res.resultModel) {
          this.chargerInfo = res.resultModel
          this.getCurveName(this.chargerInfo.curveNum)
          this._getQrCodeData(this.chargerInfo.chargerId)
        }
      })
    },
    handleStage (val) {
      // if (val == 1) return '充电阶段'
      if (val == 2) return this.$t('charger.bulk_stage')
      if (val == 3) return this.$t('charger.absorption_stage')
      if (val == 4) return this.$t('charger.finish_stage')
      if (val == 5) return this.$t('charger.end_charging')
      return '--'
    },
    handleStatus (val) {
      if (val === 0) return this.$t('charger.under_auto')
      if (val === '0') return this.$t('charger.under_auto')
      if (val == 1) return this.$t('charger.under_control')
      if (val == 2) return this.$t('charger.perform_config')
      if (val == 3) return this.$t('charger.lock_command')
      if (val == 4) return this.$t('charger.unable_output')
      if (val == 5) return this.$t('charger.interrupt_output')
      return '--'
    },
    handleError (val) {
      console.log(val)
      if (val == null || val == '' || val == undefined) return '--'

      return this.$t('chargerIndex.error_' + val)
    },
    handleTime (val) {
      if (!val) return '--'
      // console.log('时间：', val)
      return updateTime(val, this.$i18n.locale)
    },
    getChargeCurves () {
      if (this.mList.length) return
      manufacturerList().then(res => {
        console.log(res)
        if (res.resultCode == 1001 && res.resultModel) {
          this.mList = res.resultModel.filter(item => {
            if (item) return item
          })
        }
      })
    },
    getCurvesName (val) {
      console.log(val)
      this.descriptions = ''
      this.desList = []
      // descriptionList(val).then(res => {
      //   console.log(res)
      //   if (res.resultCode == 1001) {
      //     this.desList = res.resultModel
      //   }
      // })
      descriptionList2({
        manufacturer: val,
        model: this.chargerInfo.chargerModel
      }).then(res => {
        // console.log(res)
        if (res.resultCode == 1001) {
          this.desList = res.resultModel
        }
      })
    },
    curveChange (index) { // 获取曲线数据
      // console.log(index)
      let val = this.desList[index]
      // console.log(val)
      if (val.source) {
        this.confirmDis = false
        this.curveData = val.source
      } else {
        this.confirmDis = true
        this.curveData = null
      }
      // this.descriptions = val
      // findCurveBase({
      //   "descriptions": val,
      //   "manufacturer": this.manufacturer,
      //   "model": this.chargerInfo.chargerModel
      // }).then(res => {
      //   console.log('曲线数据：', res)
      //   if (res.resultCode == 1001 && res.resultModel) {
      //     this.confirmDis = false
      //     this.curveData = res.resultModel
      //   } else {
      //     this.confirmDis = true
      //     this.curveData = null
      //   }
      // })
    },

    lazyLoad (node, resolve) {
      console.log(node)
      const { level } = node;
      if (level == 0) {
        manufacturerList().then(res => {
          console.log(res)
          if (res.resultCode == 1001) {
            let mList = res.resultModel
            const nodes = mList.map(item => {
              if (item) {
                return {
                  value: item,
                  label: item
                }
              }
            })
            resolve(nodes);
          }
        })
      }

      if (level == 1) {
        descriptionList(node.label).then(res => {
          console.log(res)
          if (res.resultCode == 1001) {
            let mList = res.resultModel
            const nodes = mList.map(item => {
              if (item) {
                return {
                  value: item,
                  label: item,
                  leaf: level >= 1
                }
              }
            })
            resolve(nodes);
          }
        })
      }
    }
  }
}
</script>


<style lang="scss" scoped>
.charge_data {
  background-color: #fff;
  padding: 10px;
  margin-bottom: 20px;
  height: 480px;
  .title_box {
    margin-bottom: 20px;
    .title {
      font-size: 14px;
      font-weight: bold;
      color: #858585;
      margin-right: 20px;
    }
  }
}
.cell_groud {
  .cell {
    width: 50%;
    height: 48px;
    padding: 0 10px;
    font-size: 14px;
    line-height: 24px;
    .label {
      margin-right: 10px;
      &::after {
        content: ":";
        font-size: 16px;
        margin-left: 4px;
      }
    }
    .desc {
      font-size: 13px;
    }
  }
}
</style>